module.exports = __webpack_public_path__ + "videos/stroke-long-compressed.b6f2368.mp4";